module.exports = __webpack_public_path__ + "img/s3.41941c5d.jpg";